import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import { makeStyles } from "@material-ui/core/styles";
import TextareaField from "../TextAreaField";
import { postMentorSessionMinutes,postSessionSummaryData } from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    padding: "0.5px 0px",
  },
}));
function SessionsMomMentorModal(props) {
  const { postMentorSessionMinutes,postSessionSummaryData, sessionData, mentorshipId } = props;
  const [hideButtons ,setHideButtons] = useState(true);
  const hoursData = [{}];
  const [ratingData, setRatingData] = useState(0);
  const [discussonSummary, setDiscussonSummary] = useState("");
  const [fileData, setFileData] = useState();
  const [sessionHours, setSessionHours] = useState(0);
  const classes = useStyles();
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the purpose"
  );
  const [errorVisible, SetErrorVisible] = useState(false);
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [sessionHoursError,setSessionHoursError] = useState(false);
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minHeight: "45px",
      color: "#333",
      maxwidth:"10rem",
      fontSize:"16px"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize:"14px"
  }),
  };
  hoursData.push(
    {
      value: "0",
      label: "0.5",
    },
    { value: "1", label: "1" },
    { value: "2", label: "1.5" },
    { value: "3", label: "2" },
    { value: "4", label: "2.5" },
    { value: "5", label: "3" },
    { value: "6", label: "3.5" },
    { value: "7", label: "4" },
    { value: "8", label: "4.5" },
    { value: "9", label: "5" },
    { value: "10", label: "5.5" },
    { value: "11", label: "6" }
  );

  const handleClose = () => {
    props.setModalVisibility(false);
    setHideButtons(true);
    setSessionHours(0);
    setRatingData(0);
    setDiscussonSummary("");
    setFileData();
  };

  const ratingChanged = (newRating) => {
    setRatingData(newRating);
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    } else if (value == 251) {
      setWordCounter(250);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  const handleSubmit = () => {
    const formData = new FormData();
    if (
      ratingData > 0 &&
      discussonSummary.length > 0 &&
      sessionHours !== 0  &&
      sessionData?.sessionDuration !== "" && sessionData?.sessionDuration !== undefined
    ) {
      SetErrorVisible(false);
      let params = {
        userId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
        sessionId: sessionData.scheduleId,
        mentorshipId: mentorshipId,
        sessionFeedback: ratingData,
        discussionSummary: discussonSummary,
        sessionHours: sessionHours === 0 ? sessionData?.sessionDuration : sessionHours,
      };
      formData.append("application", JSON.stringify(params));
      formData.append("uploadSupportingFile", fileData?.uploadResume);
      if(JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role == "Mentor")
      {
        postMentorSessionMinutes(formData);
      }
      else{
        postSessionSummaryData(formData);
      }
          props.parentData(true);
          props.setModalVisibility(false);
          setSessionHours(0);
          setRatingData(0);
          setDiscussonSummary("");
          setHideButtons(true);
          setFileData();
     
    } else {
      SetErrorVisible(true);
      if(sessionHours === 0)
      setSessionHoursError(true);
    }
  };
  const handleInputChange = (e) => {
    setFileData((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
    const newFormData = {
      ...fileData,
      [e.target.name]: e.target.files[0],
    };
   
  };
 
  const firstExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value: 0,
    color: 'lightgray',
    
    activeColor: 'orange',
    onChange: (newValue) => {
      setRatingData(newValue);
    },
  };
  const handleReset = () => {
    setHideButtons(true);
  }
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };

  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => {
            props.setModalVisibility(false)
            setSessionHours(0);
            setRatingData(0);
            setDiscussonSummary("");
            setFileData();
          }}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="sessionMinutesHeading">SESSION NOTES</Modal.Title>
            <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
             <span className="tooltiptext  close-window" style={{left:"-130px",top:"2px",width:"130px"}}>Close Window</span>
         </div>
          </Modal.Header>
          <Modal.Body>
            <div className="session-detailsModal">
              <div className="feedback-session2">
                <div className="row pb-4 heightModalFix">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                    1
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding">
                    SESSION FEEDBACK*
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 starsDiv">
                    <ReactStars
                      {...firstExample}
                      half
                      onChange={ratingChanged}
                    />
                  </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                    2
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                    DISCUSSION SUMMARY*
                  </div>
                  <div
                    style={{ textAlign: "right" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 discussionSummaryBox"
                  >
                    <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Describe in maximum 250 words"
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white"}}
                      name="purpose"
                      rows={5}
                      InputProps={{ className: classes.input }}
                    
                      value={discussonSummary}
                      onChange={(e) => {
                        if (testWordLimit(e.target.value) < 251) {
                          setDiscussonSummary(e.target.value);
                        }
                      }}
                    />
                    <div className="wordCounter">
                      Word Count: {wordCounter} / 250
                    </div>

                    {errorVisible7 && (
                      <div className="login-error-msg mt-2">
                        {errorMessagePurpose}
                      </div>
                    )}
                   
                  </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                    3
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                    UPLOAD DOCUMENT
                  </div>
                  <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                    <div>
                      <div className="newuserTooltip top-btn">
                      <button
                        onClick={clickonFileinput}
                        className="newUploadBtn"
                      >
                        CLICK TO UPLOAD
                      </button>
                      <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"89px",width:"auto"}}>
                    Upload Document
                  </span>
                  </div>
                      <p
                        style={{
                          textAlign: "left",
                          paddingLeft: "10px",
                          fontSize: "16px",
                        }}
                      >
                        <br />
                        <span>Supported file format PDF only upto 2MB</span>
                      </p>
                      <div className="fileupload-resume-startup">
                        <input
                          className="resume-upload"
                          type="file"
                          id="fileUpload-resume"
                          required
                          name="uploadResume"
                          onChange={handleInputChange}
                          accept="application/pdf"
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                    {fileData && fileData?.uploadResume !== null && (
                      <div style={{ marginBottom: "50px" }}>
                        <div className="file-name" style={{ float: "left" }}>
                          {fileData?.uploadResume?.name}{" "}
                          <span
                            style={{ marginLeft: "10px" }}
                            onClick={() => removeFile("uploadResume")}
                          >
                            {" "}
                            X{" "}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                 
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-12 col-12 numdata d-flex justify-content-center">
                    4
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                    SESSION HOURS*
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 ">
                 
                    {
                        ((sessionData?.sessionDuration !== "" && sessionData?.sessionDuration !== undefined) && hideButtons) ? (
                            <>
                            <div className="d-flex">
                            <div>{sessionData?.sessionDuration}</div>
                                <div className="newuserTooltip">
                                <button className="timeOkBtn"
                                onClick={()=>{
                                    setHideButtons(true);
                                    setSessionHours(sessionData?.sessionDuration);
                                    setSessionHoursError(false);
                                }}
                                >
                                        OK
                                </button>
                                <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"59px",width:"150px"}}>
                    Click OK to Confirm
                  </span>
                                </div>
                                <div className="newuserTooltip">
                                <button className="timeNotOkBtn"  onClick={()=>{
                                    setHideButtons(false);
                                    setSessionHoursError(true);

                                }}>
                                        NOT OK
                                </button>
                                <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"66px",width:"150px"}}>
                    Click Not OK
                  </span>
                                </div>
                            </div>
                            </>
                        ):
                        (
                            <>
                            <div className="row d-flexmodalButton39">
                            <div
                    style={{ textAlign: "left", fontFamily: "Montserrat" }}
                    className="col-9"
                  >
                    <Select
                      options={hoursData}
                      styles={customStyles}
                      placeholder="Select the duration"
                      onChange={(e) => {
                        setSessionHours(e.label);
                        setSessionHoursError(false);
                      }}
                    />
                  </div> 
                  <div className="col-3 d-flex justify-content-end">
                <Button
                  onClick={handleReset}
                  text="RESET"
                  className="modalButton39 doc-upload"
                ></Button>
              </div>
              </div>
                  </>
                        )
                    }
                    {sessionHoursError && (
                      <div className="login-error-msg errorMessageFix">
                        Please confirm the session hours
                      </div>
                    )}
                        {errorVisible && (
                      <div className="login-error-msg errorMessageFix">
                        Please enter all details*
                      </div>
                    )}
                  </div>
                
                </div>
             
              </div>
          
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center feedBackFooterFix2">
            <div className="d-flex justify-between feedBackFooterFix">
              <div>
                <Button
                  onClick={handleClose}
                  text="BACK"
                  className="modalButton3 doc-upload"
                ></Button>
              </div>
              
              <div>
                <Button
                  onClick={handleSubmit}
                  text="SAVE & SUBMIT"
                  className="modalButton3 doc-uploadnext"
                ></Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, { postMentorSessionMinutes,postSessionSummaryData })(
  withRouter(SessionsMomMentorModal)
);
